module.exports = __webpack_public_path__ + "img/ar-red.66e45b9b.svg";